import React, {useState, useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {Box, CircularProgress, DialogTitle} from "@material-ui/core";
import {DashboardStyles} from "../../../styles/dashboard";
import Select from "@material-ui/core/Select";
import {getFormData, inputChangedHandler, prepareFormData, validateForm} from "../../../shared/utility";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import * as actions from "../../../store/actions";
import {connect} from "react-redux";
import Alert from "@material-ui/lab/Alert";
import {Topics} from "../../../store/actions/messages";

const useStyles = makeStyles(DashboardStyles);

let formData = {
    controls: {
        topic: {
            value: "",
            validation: {
                presence: {allowEmpty: false, message: 'Please choose a topic'},
                //length: {maximum: 17, minimum: 10}
            },
            values: [].concat(Topics.getList()),
            valid: false,
            touched: false,

        },
        message: {
            label: 'Message',
            value: '',
            validation: {
                presence: {allowEmpty: false}
            },
            valid: false,
            touched: false,
            visible: false
        },
    },

    loading: false,
    valid: false,
    touched: false,
    generalError: null

}

const MessageModal = (props) => {
    const classes = useStyles();
    formData = prepareFormData(formData);
    const cancelAction = () =>{
        resetForm()
        props.handleClose()
    }
    const resetForm = () =>{
        formData.controls.topic.value =  ''
        formData.controls.topic.touched =  false
        formData.controls.message.value =  ''
        formData.controls.message.touched =  false
        formData = prepareFormData(formData)
        setFormState(formData)
    }

    const submitHandler = (event) => {
        event.preventDefault();
        if (validateForm(formState, setFormState)) {
            const data = getFormData(formState)
            props.onSendMessage(data.topic,data.message, cb => {
                cancelAction()
                props.onSuccess()
            })
        }
    }
    const [formState, setFormState] = useState(formData);
    const topicField = formState.controls.topic;
    const messageField = formState.controls.message;

    useEffect(() => {
        const selectedValue = topicField.values.find((row) => row.key === props.messages.selectedTopic);
        if (selectedValue) {
           inputChangedHandler(formState, setFormState, selectedValue.name, topicField.key)
        }
    }, [props.messages.selectedTopic]); // formState, topicField.values, topicField.key
    
    return (
        <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title" PaperProps={{ classes: {root: classes.dialogPaper } }}>
            <DialogTitle id="form-dialog-title" className={classes.dialogTitle}  disableTypography>Message Carwiser</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <Box className={classes.dialogText}>What can we help with?</Box>

                <FormControl className={classes.formControl} fullWidth
                             error={!topicField.valid && topicField.touched} margin={"normal"}>
                    <Select
                        labelId="{colorField.key}-label"
                        id={topicField.key}
                        value={topicField.value}
                        displayEmpty
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, topicField.key)}
                        error={!topicField.valid && topicField.touched}
                    >
                        <MenuItem className={classes.MenuItem} value="">
                            <em>--Select--</em>
                        </MenuItem>
                        {topicField.values.map((item, index) => {
                            return <MenuItem className={classes.MenuItem} value={item.name} key={index}>{item.name}</MenuItem>
                        })
                        }
                    </Select>
                    <FormHelperText>{topicField.helperText?? topicField.label}</FormHelperText>
                </FormControl>

                <TextField
                    InputProps={{
                        className: classes.messageTextArea,
                    }}
                    name={messageField.key}
                    value={messageField.value}
                    type={'input'}
                    fullWidth
                    margin="normal"
                    multiline
                    rows={'10'}
                    onChange={event => inputChangedHandler(formState, setFormState, event.target.value, messageField.key)}
                    helperText={messageField.helperText}
                    variant="outlined"
                    error={!messageField.valid && messageField.touched}
                />
                {props.messages.error &&
                <div className={`$classes.wrapper `}>
                    <Alert severity="error">{props.messages.error ?? ''}</Alert>
                </div>
                }

            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button  size={"small"} variant="outlined" onClick={cancelAction}>
                    Cancel
                </Button>
                <Button  size='small' color="primary"   variant="contained" onClick={submitHandler}>
                    Submit
                    {props.messages.loading &&
                    <CircularProgress size={30} className={classes.buttonProgress} color="secondary"/>}
                </Button>
            </DialogActions>
        </Dialog>
    );

}


const mapStateToProps = state => {
    return {
        messages: state.messages
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSendMessage: (subject,message, cb) => dispatch(actions.sendMessage(subject,message, cb))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageModal);
